import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '../ui/Spinner';
import { Button } from '../ui/Button';
import { useAuth } from '../../lib/clerk';
import { useCurrentUser } from '../../features/auth/useCurrentUser';

type AdminRouteGuardProps = {
  children: ReactNode;
};

export function AdminRouteGuard({ children }: AdminRouteGuardProps) {
  const { isLoaded, isSignedIn } = useAuth();
  const currentUser = useCurrentUser(isLoaded && isSignedIn !== false);

  if (!isLoaded || currentUser.isLoading) {
    return <div className="flex h-screen items-center justify-center"><Spinner className="h-8 w-8" /></div>;
  }

  if (isSignedIn === false) {
    return <Navigate to="/sign-in" replace />;
  }

  if (currentUser.isError) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <div role="alert" className="max-w-md space-y-4 text-center">
          <p>Unable to verify administrator access.</p>
          <Button variant="outline" onClick={() => void currentUser.refetch()}>Try again</Button>
        </div>
      </div>
    );
  }

  if (currentUser.data?.role !== 'SYSTEM_ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
